export interface SocialAccountOption{
    id: string,
    value: string,
    socialPlatform: string
}

export interface SocialPostTypeOption{
    id: string,
    value: string,
    socialPlatforms: string[]
}

export interface SocialPlatformOption{
    id: string,
    value: string,
}

export interface SocialPlatformOptionObject{
    socialPlatforms: SocialPlatformOption[],
    socialPostTypes: SocialPostTypeOption[],
    socialAccounts: SocialAccountOption[]
}

interface BasePost{
    "social_content_id": string,
    "social_account_id": string,
}

interface DailyMotionPostInfos{
    "title": string,
    "description": string,
    "channel_id": string,
    "private": boolean,
    "is_created_for_kids": boolean,
    "tags": []
}

interface YoutubePostInfos{
    "title": string,
    "description": string,
    "privacy_status": string,
    "tags": []
}

interface FacebookPostInfos{
    "title": string,
    "description": string,
}

interface InstagramPostInfos{
    caption?: string,
}

export type DailyMotionPostRequest = BasePost & DailyMotionPostInfos;

export type FacebookPostRequest = BasePost & FacebookPostInfos

export type InstagramPostRequest = BasePost & InstagramPostInfos;

export type YoutubePostRequest = BasePost & YoutubePostInfos;

export type SocialPostRequest = DailyMotionPostRequest | FacebookPostRequest | InstagramPostRequest | YoutubePostRequest;

type PostStatus = 'published' | 'in_progress' | 'failed' | 'processing'

export interface SocialContentPublication {
    content_publication_id: string;
    social_content_id: string;
    social_account_id: string;
    social_clip_id: string;
    publication_id: string;
    status: PostStatus
    publication_url: string;
    published_at: string;
    aspect_ratio: string
    publish_info: DailyMotionPostInfos;
    insights: {
        viewCount: number;
        likeCount: number;
        commentCount: number;
        shareCount: number;
        saveCount: number;
        other_metrics: any;
    }
    materialization: {id: string, aspect_ratio: number}
    draft: boolean
}

export interface EnrichedSocialContentPublication extends SocialContentPublication {
    social_account_name: string;
    social_content_name: string;
    social_platform_name: string;
}

export enum SocialPlatformNames{
    dailyMotion = "dailymotion",
    facebook = "facebook",
    instagram = "instagram",
    youtube = "youtube",
    tiktok = "tiktok",
    telegram = "telegram"
}

export enum SocialPostNames{
    reel = "reel",
    video = "video",
    story = "story",
}

export interface SocialAccount {
    id: string;
    name: string;
    account_id: string;
    business_id: string;
    app_id: string;
    page_id: string;
    page_access_token: string;
    client_id: string;
    client_secret: string;
    is_token_valid: boolean;
    auth_code: string;
    redirect_uri: string;
    social_platform: SocialPlatform
    token?: string
    mode?: 'readonly' | 'updatable'
    refresh_time?: string;
}

export interface SocialPlatform{
    id: string,
    name: SocialPlatformNames,
    deletion_support: boolean;
    social_contents_supported: SocialPostType[]
    accounts?: SocialAccount[]
}

interface SocialPostType {
    id: string,
    type: string
}

export interface SocialFormControl{
    name: keyof SocialAccount | 'sendButton';
    type: 'text' | 'sendButton';
    label: string,
    secret?: boolean,
    visibleUpdate?: boolean,
    visibleCreate?: boolean,
}

export interface Option{
    value: string;
    id: string
}


